import React, { useMemo } from 'react';
import { InlineNotification, TextInput } from 'carbon-components-react';
import { StripePaymentCard, PricingSummary } from 'components/PremiumWizard';
import { StripePrice } from 'redux/bulkEnquiryLodgement/types';

interface PaymentStepProps {
  stripePrice: StripePrice | null;
  error: string | null;
  purchaseOrderNumber: string;
  onPurchaseOrderNumberChange: (purchaseOrderNumber: string) => void;
}

const PaymentStep: React.FC<PaymentStepProps> = ({
  stripePrice,
  error,
  purchaseOrderNumber,
  onPurchaseOrderNumberChange
}) => {
  const { displayAmount, displayCurrency, lineItems, total } = useMemo(() => {
    const formatted = stripePrice?.formatted?.trim();
    const currency = stripePrice?.currency?.toUpperCase() || 'AUD';
    const feeLabel = stripePrice?.formattedWithTax || formatted || '—';
    const amountWithoutCurrency = formatted
      ? formatted.replace(/\s*AUD\s*/i, '')
      : '—';
    return {
      displayAmount: amountWithoutCurrency,
      displayCurrency: currency,
      lineItems: [
        { label: 'Large area enquiries', amount: amountWithoutCurrency }
      ],
      total: { label: 'Total', amount: feeLabel }
    };
  }, [stripePrice]);

  return (
    <div className="bel-payment-step">
      <div className="bel-payment-step__heading">Invoice</div>

      <div className="bel-payment-step__notification">
        <InlineNotification
          kind="info"
          title=""
          subtitle="Your account is authorised for post-payment. An invoice will be sent to your registered email upon confirmation."
          lowContrast
          hideCloseButton
        />
      </div>

      {error && (
        <div className="bel-payment-step__notification">
          <InlineNotification
            kind="error"
            title=""
            subtitle={error}
            lowContrast
            hideCloseButton
          />
        </div>
      )}

      <div className="bel-payment-step__card-wrapper">
        <StripePaymentCard
          amount={displayAmount}
          currency={displayCurrency}
          description="Large area enquiries &middot; One-time &middot; Invoice"
        />
      </div>

      <div className="bel-payment-step__order-input">
        <TextInput
          id="purchase-order-number"
          labelText="Purchase order number (optional)"
          placeholder="Max 255 characters"
          maxLength={255}
          value={purchaseOrderNumber}
          onChange={(event) => onPurchaseOrderNumberChange(event.target.value)}
        />
      </div>

      <div className="bel-payment-step__summary">
        <div className="bel-payment-step__summary-heading">Invoice summary</div>
        <PricingSummary
          lineItems={lineItems}
          total={total}
          showHeader
          variant="payment"
        />
      </div>
    </div>
  );
};

export default PaymentStep;
